import React from 'react'

export interface ArrowDownCircleProps {
  size?: number
  color?: string
}

export const ArrowDownCircle: React.FC<ArrowDownCircleProps> = ({
  size = 24,
  color = '#fff',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_35188_68635)" fill={color}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30 60c16.569 0 30-13.432 30-30C60 13.431 46.57 0 30 0 13.431 0 0 13.431 0 30c0 16.568 13.431 30 30 30zm0-6c13.255 0 24-10.745 24-24S43.255 6 30 6 6 16.745 6 30s10.745 24 24 24z"
        />
        <path
          d="M29.968 43.25a1.996 1.996 0 01-1.442-.618h0l-8.954-9.065a1.05 1.05 0 010-1.475l1.398-1.416a1.05 1.05 0 011.494 0l5.455 5.522V17.8c0-.58.47-1.05 1.05-1.05h1.999c.58 0 1.05.47 1.05 1.05v18.412l5.522-5.54a1.05 1.05 0 011.49.003l1.399 1.416a1.05 1.05 0 01-.003 1.477l-9.017 9.067v-.001a2.007 2.007 0 01-1.441.616z"
          stroke={color}
          strokeWidth={1.5}
        />
      </g>
      <defs>
        <clipPath id="clip0_35188_68635">
          <path fill={color} d="M0 0H60V60H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
